import { CondensedButton, IconDownloadLine, Text } from "@instructure/ui";
import { useTranslation } from "react-i18next";
import { get } from "idb-keyval";
import downloadFile from "../../../../../utils/Dom";

const UploadScoresSummary = ({ assignmentName }) => {
  const { t } = useTranslation();

  return (
    <Text>
      <Text weight="bold">{t("finalizeCourse.fileToBeUploaded")}: </Text>
      <CondensedButton
        renderIcon={IconDownloadLine}
        onClick={async () => {
          const file = await get("uploadFile");
          if (file) {
            const csvBlob = new Blob([file], { type: "text/csv" });
            const url = URL.createObjectURL(csvBlob);
            downloadFile(url, file.name);
          } else {
            console.error("No file found");
          }
        }}
      >
        {assignmentName}
      </CondensedButton>
    </Text>
  );
};

export default UploadScoresSummary;
